<template>
    <div class="user-avatar-dropdown">
        <Dropdown @on-click="handleClick">
            <!-- <Badge :dot="!!messageUnreadCount">
                <Avatar :src="userAvatar" />
            </Badge> -->
            <!-- <span><strong>{{shopName !== '' ? shopName + ' - ' : ''}}{{ userNickName }}({{ userName }})</strong></span> -->
            <span><strong>{{ userNickName }}({{ userName }})</strong></span>
            <Icon :size="18"
                type="md-arrow-dropdown"></Icon>
            <DropdownMenu slot="list">
                <!-- <DropdownItem name="message">
                    消息中心<Badge style="margin-left: 10px"
                        :count="messageUnreadCount"></Badge>
                </DropdownItem> -->
                <DropdownItem name="changePassword">个人中心</DropdownItem>
                <DropdownItem name="logout">退出登录</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>

<script>
import './user.less';
import { mapActions, mapMutations } from 'vuex';
export default {
    name: 'User',
    props: {
        userAvatar: {
            type: String,
            default: ''
        },
        userName: {
            type: String,
            default: ''
        },
        userNickName: {
            type: String,
            default: ''
        },
        shopName: {
            type: String,
            default: ''
        },
        messageUnreadCount: {
            type: Number,
            default: 0
        }
    },
    methods: {
        ...mapMutations([
            'setTagNavList'
        ]),
        ...mapActions([
            'handleLogOut'
        ]),
        logout() {
            this.handleLogOut().then(() => {
                //退出时，关闭所有tab
                let res = this.$store.state.app.tagNavList.filter(item => item.name === this.$config.homeName);
                this.setTagNavList(res);

                this.$router.push({
                    name: 'login'
                });
            });
        },
        message() {
            this.$router.push({
                name: 'message_page'
            });
        },
        changePassword() {
            this.$router.push({
                name: 'system-user-center'
            });
        },
        handleClick(name) {
            switch (name) {
                case 'logout': this.logout();
                    break;
                case 'message': this.message();
                    break;
                case 'changePassword': this.changePassword();
                    break;
            }
        }
    }
};
</script>
